<script>
  import { createNamespacedHelpers } from 'vuex';
  import InputLayout from './InputLayout';
  import CustomOptions from './CustomOptions';
  import SymbolsLayout from '../SymbolsLayout';

  const { mapGetters } = createNamespacedHelpers('plate');

  export default {
    name: 'EditLayout',
    components: {
      InputLayout,
      CustomOptions,
      SymbolsLayout,
    },
    props: {
      /** Number of lines of text the base product can include */
      lines: {
        type: [Number, String],
        required: true,
      },
      /** The horizontal space on the base product */
      space: {
        type: [Number, String],
        required: true,
      }
    },
    data() {
      return {
        bundleData: null,
      };
    },
    computed: {
      ...mapGetters([
        'getSelectedLetterStyle',
        'getSelectedBaseProduct',
        'getSelectedVariant'
      ]),
    },
  };
</script>

<template>
  <div class="product-view__edit">
    <div class="letter-edit">

      <div v-if="getSelectedVariant && getSelectedLetterStyle">
        <InputLayout :lines="lines" :space="space" />
        <CustomOptions :variant="getSelectedVariant" :letterStyle="getSelectedLetterStyle" />
        <SymbolsLayout :lettersData="getSelectedLetterStyle.chars" />
      </div>

      <div v-else class="x-loading">
        <span class="loading" />
      </div>

    </div>
  </div>
</template>
